/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReadResourceRequest
 */
export interface ReadResourceRequest {
    /**
     * RID of the resource
     * @type {string}
     * @memberof ReadResourceRequest
     */
    rID: string;
}

/**
 * Check if a given object implements the ReadResourceRequest interface.
 */
export function instanceOfReadResourceRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "rID" in value;

    return isInstance;
}

export function ReadResourceRequestFromJSON(json: any): ReadResourceRequest {
    return ReadResourceRequestFromJSONTyped(json, false);
}

export function ReadResourceRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReadResourceRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'rID': json['RID'],
    };
}

export function ReadResourceRequestToJSON(value?: ReadResourceRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'RID': value.rID,
    };
}

